// Copyright (C) 2021 Bystronic Laser AG

/**
 * Specifies periods of time relative to the current date.
 */
export enum FilterTimeSpanEnum {
  None = 0,
  Day = 1,
  Week = 2,
  Month = 3,
  Year = 4,
}
